import React, {FC} from "react"
import {match as Match} from "react-router-dom"

import {InjectIntl, injectIntl} from "@irati/utils/lang"
import {NestedRoute} from "@irati/utils/history/routing"
import Account from "../containers/Account"

interface Props extends InjectIntl {
  match: Match
}

const AccountRoute: FC<Props> = ({match}) => {
  return <NestedRoute match={match.url} path="/:recognitionType" title="My celebration" component={Account} />
}

export default injectIntl(AccountRoute)
